export default __webpack_public_path__ + "static/media/chevron_down.a4f409dd.svg";